var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrassTop = function SvgGrassTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3514 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 33.5C63.5 33.5 18.5 51 0 51h3514c-92 0-165.5-25-285.5-25s-242 10.5-372 10.5-547-36-714.5-36-417.5 26-551.5 26-448-3.5-526.5-3.5-547.5 22.5-632 22.5-254.5-12-311.5-12Z",
    fill: "#57C975"
  })));
};
export default SvgGrassTop;